module.exports = __webpack_public_path__ + "assets/img/swiper-tip.87b84af8.png";